export default __webpack_public_path__ + "static/media/validasi-manajer-office.5b7a9d64.png";